/* eslint-disable no-param-reassign */
import { valueByPixels } from './fromPhoebe/valueByPixels';
import { scaleSelector } from './fromPhoebe/scaleSelector';

const fontSize = 12;
const padding = 2;
const content = 'Отменить приближение';
const contentWidthPixels = 150;
const contentHeightPixels = fontSize + padding * 2;
const zoomCancelAnnotationName = 'zoomCancelAnnotation';
export const createZoomAnnotations = (doSyncInGroup) => ({
  [zoomCancelAnnotationName]: {
    display: false,
    type: 'box',
    borderColor: 'rgb(121,121,121)',
    backgroundColor: 'rgba(204,159,159,0.38)',
    borderWidth: 1,
    label: {
      enabled: true,
      content,
      position: 'start',
      padding,
      color: 'black',
      font: {
        size: fontSize,
      },
    },
    // умножаем на -1, чтобы инвертировать положение справа налево
    xMin: valueByPixels(-1 * contentWidthPixels, scaleSelector('x')),
    // умножаем на -1, чтобы инвертировать положение снизу на верх
    yMax: valueByPixels(-1 * contentHeightPixels, scaleSelector('y')),
    click: ({ chart: targetChart }) => {
      if (!doSyncInGroup || !targetChart.group?.charts?.length) {
        setZoomAnnotationDisplay(targetChart, false);
        targetChart.resetZoom();
        return;
      }

      targetChart.group.charts.forEach((chart) => {
        setZoomAnnotationDisplay(chart, false);
        chart.resetZoom();
      });
    },
    enter: ({ chart }) => {
      chart.canvas.style.cursor = 'pointer';
    },
    leave: ({ chart }) => {
      chart.canvas.style.cursor = 'default';
    },
  },
});

function setZoomAnnotationDisplay(chart, display) {
  chart.options.plugins.annotation.annotations[zoomCancelAnnotationName].display = display;
}

const msInDay = 1000 * 60 * 60 * 24;

export function getZoomPluginOptions(doSyncInGroup, minRange = msInDay, disableZoom = false) {
  return {
    pan: {
      enabled: !disableZoom,
      mode: 'x',
      modifierKey: 'shift',
      onPan: ({ chart: targetChart }) => {
        if (!doSyncInGroup || !targetChart.group?.charts?.length) {
          setZoomAnnotationDisplay(targetChart, true);
          targetChart.update();
          return;
        }

        targetChart.group.charts.forEach((chart) => {
          if (chart !== targetChart) {
            // Sync the zoom level for other charts
            chart.zoomScale('x', targetChart.scales.x, 'zoom');
          }
          chart.update();
        });
      },
    },
    limits: {
      x: {
        min: 'original',
        max: 'original',
        minRange,
      },
    },
    zoom: {
      drag: {
        enabled: !disableZoom,
      },
      pinch: {
        enabled: !disableZoom,
      },
      mode: 'x',
      onZoom: ({ chart: targetChart }) => {
        if (!doSyncInGroup || !targetChart.group?.charts?.length) {
          setZoomAnnotationDisplay(targetChart, true);

          targetChart.update();
          return;
        }

        targetChart.group.charts.forEach((chart) => {
          setZoomAnnotationDisplay(targetChart, true);
          if (chart !== targetChart) {
            // Sync the zoom level for other charts
            chart.zoomScale('x', targetChart.scales.x, 'zoom');
          }
          chart.update();
        });
      },
    },
  };
}
